// extracted by mini-css-extract-plugin
export default {"arrowBg":"PopOverArrow-module__arrowBg--VVYHW","arrowStroke":"PopOverArrow-module__arrowStroke--QiDiX"};